/**
 * Normalise une URL externe saisie par une association (site web, réseaux
 * sociaux) avant de la rendre dans un href ou un Schema.org sameAs.
 *
 * Pourquoi : ces champs sont du texte libre côté dashboard/Directus. Une
 * valeur sans protocole (« donoor.org », « facebook.com/mapage ») rendue
 * telle quelle dans un <a :href> devient un lien RELATIF : sur la page
 * /associations/mon-asso, le navigateur résout « donoor.org » en
 * /associations/donoor.org → 404 crawlé par Google/SemRush (audit
 * 2026-08-05, org « organisation-de-donoor »).
 *
 * Retourne null si la valeur est vide/inutilisable → le template masque le
 * lien via v-if plutôt que de rendre un href cassé.
 */
export function normalizeExternalUrl(
  url: string | null | undefined,
): string | null {
  const trimmed = url?.trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  // Refuse les autres schémas explicites (mailto:, javascript:, ftp:…) :
  // hors sujet pour un site web / réseau social, et javascript: serait un
  // vecteur XSS via href.
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return null;
  return `https://${trimmed.replace(/^\/+/, "")}`;
}
